module.exports = __webpack_public_path__ + "static/media/img05.4f7ef107.JPG";